module.exports = __webpack_public_path__ + "img/logo.38600b1b.svg";